import * as React from "react";
import LoadingIcon from "../../common/components/LoadingIcon";
import strings from "../../common/utils/StringManager";
import IResultItem from "./IResultItem"; 

interface IItemResourceProps {
	item: IResultItem,
	onRequestLoad: (item: IResultItem) => void,
}

interface IItemResourceState {
	open: boolean
}

export class ItemResource extends React.Component<IItemResourceProps, IItemResourceState> {
	constructor(props) {
		super(props);

		this.state = {
			open: false,
		}
	}

	openIssues() {
		this.setState({ open: !this.state.open });
		if (!this.props.item.Issues) {
			this.props.onRequestLoad(this.props.item);
		}
	}

	render() {
		
		let opened = null;
		if (this.state.open) {
			let items = [];
			if (this.props.item.Issues) {
				items = this.props.item.Issues.map(i => {
					return (<p key={i.IssueId}> <a href={i.Url} className="link" >#{i.IssueId}: {i.Subject}</a></p>);
				})
			}
			if (!this.props.item.Issues || this.props.item.loading) {
				items.push(<p key={"loading"}><LoadingIcon /></p>);
			}
			else if (this.props.item.Issues.length < this.props.item.IssueCount) {
				items.push(<div key={"more"} className="qd-btn qd-btn-text" onClick={() => this.props.onRequestLoad(this.props.item)}>{strings.get("more")}...</div>);
			}

			opened = <div className="resource-item-body">{items}</div>
		}

		var icon = null;
		if (this.state.open) {
			icon = <i className="colapse-icon material-icons">expand_less</i>
		}
		else {
			icon = <i className="colapse-icon material-icons">expand_more</i>
		}

		return <div className="resource-item">
			<p onClick={this.openIssues.bind(this)} className="resource-item-header">
				{icon}
				<span className="name" title={strings.get("name")}>{this.props.item.Name}</span>
				{this.props.item.SerialNumber && <span className="serialNumber label-box" title={strings.get("serialNumber")}>
					<span className="label">{strings.get("serialNumber")}:</span>
					{this.props.item.SerialNumber}
				</span>}
				{this.props.item.STNumber && <span className="stNumber label-box" title={strings.get("STNumber")}>
					<span className="label">{strings.get("STNumber")}:</span>
					{this.props.item.STNumber}
				</span>}
				<span className="issueCount">({this.props.item.IssueCount})</span>
			</p>
			{opened}
		</div>
	}
}